import {
  UPDATE_ACTIVITY_FILTER,
  UPDATE_PLAY_TYPE_FILTER,
  UPDATE_MATERIALS_FILTER,
  UPDATE_MINUTES_FILTER,
  UPDATE_PLAYERS_FILTER,
  RESET_FILTERS,
} from 'js/store/search/Search.actions.js';

const initState = {
  filters: {
    activity: false,
    playType: [],
    players: [],
    minutes: [],
    avoidMaterials: false,
  },
};

const search = (state = initState, action) => {
  let nextState = {};

  switch (action.type) {
    case RESET_FILTERS:
      return { ...state, ...initState };

    case UPDATE_ACTIVITY_FILTER:
      nextState.filters = {
        ...state.filters,
        activity: action.payload,
      };
      return { ...state, ...nextState };

    case UPDATE_PLAY_TYPE_FILTER: {
      if (state.filters.playType.includes(action.payload)) {
        nextState.filters = {
          ...state.filters,
          playType: state.filters.playType.filter((id) => id !== action.payload),
        };
        return { ...state, ...nextState };
      }

      nextState.filters = {
        ...state.filters,
        playType: [...state.filters.playType, action.payload],
      };
      return { ...state, ...nextState };
    }

    case UPDATE_PLAYERS_FILTER: {
      if (state.filters.players.includes(action.payload)) {
        nextState.filters = {
          ...state.filters,
          players: state.filters.players.filter((id) => id !== action.payload),
        };
        return { ...state, ...nextState };
      }

      nextState.filters = {
        ...state.filters,
        players: [...state.filters.players, action.payload],
      };
      return { ...state, ...nextState };
    }

    case UPDATE_MINUTES_FILTER: {
      if (state.filters.minutes.includes(action.payload)) {
        nextState.filters = {
          ...state.filters,
          minutes: state.filters.minutes.filter((id) => id !== action.payload),
        };
        return { ...state, ...nextState };
      }

      nextState.filters = {
        ...state.filters,
        minutes: [...state.filters.minutes, action.payload],
      };
      return { ...state, ...nextState };
    }

    case UPDATE_MATERIALS_FILTER:
      nextState.filters = {
        ...state.filters,
        avoidMaterials: action.payload,
      };
      return { ...state, ...nextState };

    default:
      break;
  }
  return state;
};

export default search;
